import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { StringValidator } from 'src/core/validators/shared/string.validator';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';

@Component({
  selector: 'ca-ai-evaluator-settings',
  templateUrl: './ai-evaluator-settings.component.html',
  styleUrls: ['./ai-evaluator-settings.component.scss'],
  standalone: false,
})
export class AIEvaluatorSettingsComponent implements OnInit {
  aiEvaluatorForm: FormGroup;

  private readonly prefix = 'AIEvaluator';
  private readonly apiAddress = this.prefix + '.ApiAddress';
  private readonly identityBaseUrl = this.prefix + '.IdentityBaseUrl';
  private readonly clientId = this.prefix + '.ClientId';
  private readonly clientSecret = this.prefix + '.ClientSecret';
  private readonly project = this.prefix + '.Project';

  constructor(
    private config: ConfigStateService,
    private fb: FormBuilder,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService,
  ) {
    this.aiEvaluatorForm = this.fb.group({
      apiAddress: this.fb.group({
        name: this.apiAddress,
        value: [
          this.config.getSetting(this.apiAddress),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      identityBaseUrl: this.fb.group({
        name: this.identityBaseUrl,
        value: [
          this.config.getSetting(this.identityBaseUrl),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      clientId: this.fb.group({
        name: this.clientId,
        value: [
          this.config.getSetting(this.clientId),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      clientSecret: this.fb.group({
        name: this.clientSecret,
        value: [
          this.config.getSetting(this.clientSecret),
          {
            validators: [StringValidator.whitespace],
          },
        ],
      }),
      project: this.fb.group({
        name: this.project,
        value: [
          this.config.getSetting(this.project),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
    });
  }

  ngOnInit(): void {}

  onSubmitAiEvaluatorForm(eventArgs): void {
    if (!this.aiEvaluatorForm.valid) {
      return;
    }
    
    const settings: ConfigurationSettingsDto[] = [];
    settings.push(
      {
        settingName: this.aiEvaluatorForm.get('apiAddress').get('name').value,
        settingValue: this.aiEvaluatorForm.get('apiAddress').get('value').value.trim(),
      },
      {
        settingName: this.aiEvaluatorForm.get('identityBaseUrl').get('name').value,
        settingValue: this.aiEvaluatorForm.get('identityBaseUrl').get('value').value.trim(),
      },
      {
        settingName: this.aiEvaluatorForm.get('clientId').get('name').value,
        settingValue: this.aiEvaluatorForm.get('clientId').get('value').value.trim(),
      },
      {
        settingName: this.aiEvaluatorForm.get('project').get('name').value,
        settingValue: this.aiEvaluatorForm.get('project').get('value').value.trim(),
      },
    );

    if (this.aiEvaluatorForm.get('clientSecret').get('value').value) {
      settings.push({
        settingName: this.aiEvaluatorForm.get('clientSecret').get('name').value,
        settingValue: this.aiEvaluatorForm.get('clientSecret').get('value').value.trim(),
      });
    }

    this.settingService.saveSetting(settings).subscribe(() => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SavedSuccessfully'),
      );
      this.config.refreshAppState();
    });
  }
}
